import ActionType from 'store/actionTypes';

export default function alert(alert?: string) {
  return {type: ActionType.AUTH_ALERT, data: {alert}};
}
